module.exports = __webpack_public_path__ + "img/rocket_launch.d24e098b.webp";